module.exports = __webpack_public_path__ + "media/images/aloe/illustrations/login-6bf38564481950bd02923978e95a81d2.svg";